import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';

import './style.css';

class Users extends Component {
    constructor(props) {
        super(props);

        this.state = {
            fetchData:null
            ,openModal:false
            ,order:'asc'
            ,orderBy:'Name'
            ,page:0
            ,rowsPerPage:10
            ,tableLoading:false
            ,loginLevel:this.props.loginData.AccessLevel
        };
    }

    componentDidMount() {
        this.setState({tableLoading:true});
        fetch(API + "getusers")
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    deleteRow = (userId) => {
        if(window.confirm("Tem a certeza que quer apagar este utilizador?")){
            this.setState({tableLoading:true});
            fetch(API + 'deleteuser&userid=' + userId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["user_" + userId])).remove();
            });
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchusers&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data, tableLoading:false }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    render() {
        const { isAdmin, loginData, config} = this.props;
        let users = this.state.fetchData!=null ? this.state.fetchData.data : [];

        const loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'Name', active: true, numeric: false, label: 'Nome' },
                  { id: 'Username', numeric: false, label: 'Nome de Utilizador' },
                  { id: 'Email', numeric: false, label: 'Email' },
                  { id: 'AccessLevel', numeric: false, label: 'Nível de Acesso' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        if(this.state.loginLevel > 0)
            users = users.filter(user => user.AccessLevel > 0);

        return (
            <div id="usersPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-users"></i> Utilizadores <span className="arrayCount">({users.length})</span>
                            { (isAdmin || loginData.profile.Users.ADD) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Utilizador"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Users/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={users.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(users, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(user =>
                            <TableRow key={user.Id} className="tableRow" ref={"user_" + user.Id}>
                                <TableCell data-title="Nome" className="tableCell">{user.Name}</TableCell >
                                <TableCell data-title="Nome de Utilizador" className="tableCell"><div className="smallColorDiv" style={{backgroundColor: user.UserColor}}></div>{user.Username}</TableCell >
                                <TableCell data-title="Email" className="tableCell">{user.Email}</TableCell >
                                <TableCell data-title="Nível de Acesso" className="tableCell">{user.AccessName + " (nível: " + user.AccessLevel + ")"}</TableCell >
                                <TableCell data-title="Ativo" className="tableCell smallerCell">{booleanConvert(user.IsActive)}</TableCell >
                                <TableCell data-title="Ações" className="tableCell actions actionsBig" data-row-id={user.Id}>
                                    { config.features.profile && (isAdmin || loginData.profile.Users.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Perfil"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Users/UserProfile/"+user.Id+"/"+user.Name}><i className="far fa-id-badge"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    { (isAdmin || loginData.profile.Users.permission === 1) &&
                                        <Tooltip
                                            title={"Editar Utilizador"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Users/"+user.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    { loginData.profile.Users && loginData.profile.Users.permission === 2 &&
                                        <Tooltip
                                            title={"Ver Utilizador"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Users/"+user.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    { (isAdmin || loginData.profile.Users.DEL) &&
                                        <Tooltip
                                            title={"Eliminar Utilizador"}
                                            enterDelay={200}>
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(user.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell >
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={users.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Users;
